import { Controller } from '@hotwired/stimulus';
import AutoSave from 'stimulus/auto_save';

// Exclusivity, keyboard navigation and form submission are native to
// `<input type="radio">`, so the controller only persists the choice when an
// auto-save url is given, then announces the change so an enclosing
// controller can react to the selection.
export default class extends Controller {
  static targets = ['input'];

  static values = {
    autoSaveUrl: String,
    // A radio click is a deliberate, final choice, so it saves immediately.
    debounce: { type: Number, default: 0 }
  };

  connect() {
    this.autoSave = new AutoSave({
      url: this.autoSaveUrlValue,
      name: this.inputTarget.name,
      debounce: this.debounceValue,
      label: this.identifier,
      element: this.element
    });
  }

  disconnect() {
    this.autoSave.cancel();
  }

  handleChange() {
    if (this.autoSaveUrlValue) this.autoSave.save(this.inputTarget.value);

    this.dispatch('change', {
      detail: { name: this.inputTarget.name, value: this.inputTarget.value }
    });
  }
}
